import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getMediaUrl } from '@onesource/services';
import { MdOutlineAssignment } from 'react-icons/md';
import type { CardProps } from './types';

export const FormCard = ({ block, onClick }: CardProps) => (
  <Box
    onClick={onClick}
    sx={{
      width: 107,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 1.25,
      textDecoration: 'none',
      cursor: 'pointer',
      transition: 'all 0.2s',
      '&:hover': { opacity: 0.8, transform: 'translateY(-2px)' },
    }}
  >
    <Box sx={{ width: 53, height: 65, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {block.textBannerUrl && getMediaUrl(block.textBannerUrl) ? (
        <Box
          component="img"
          src={getMediaUrl(block.textBannerUrl)}
          alt={block.title || 'Form'}
          sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <MdOutlineAssignment size={48} color="#d32f2f" />
      )}
    </Box>
    <Typography variant="caption" sx={{ color: '#808080', fontSize: '12px', textAlign: 'center', lineHeight: 1.3 }}>
      {block.title || 'Form'}
    </Typography>
  </Box>
);
